import { render, staticRenderFns } from "./ActivtionRegister.vue?vue&type=template&id=e37725e4&"
import script from "./ActivtionRegister.vue?vue&type=script&lang=js&"
export * from "./ActivtionRegister.vue?vue&type=script&lang=js&"
import style0 from "./ActivtionRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports